import React, { useEffect, useState } from "react";
import { Counter, EventCommentData, UserShortInfo } from "../../types";
import ShortManInfo from "../ui/shortItem";
import { formatDateOfEvent } from "../../utils";
import { LikeIcon } from "../../icons/comment/like";
import { DislikeIcon } from "../../icons/comment/dislike";
import { CommentOutput } from "../../services/comment";
import { userBackend } from "../../services";
import CommentLikeRow from "./likes";

const CommentItem = (props: { data: CommentOutput; tab_id: number }) => {
  const { comment, date_created, user_id, id, likes, dislikes } = props.data;
  const [author, setAuthor] = useState<UserShortInfo | null>(null);

  useEffect(() => {
    if (user_id) {
      userBackend.userShortInfo(user_id).then((res) => {
        if (res) {
          setAuthor(res.user);
        }
      });
    }
  }, []);

  const authorInfo = {
    ...author,
    name: author?.first_name
      ? `${author?.last_name || ""} ${author?.first_name || ""}`
      : author?.name || "",
  };

  const likeCounters: Counter[] = [
    {
      value: 1,
      count: likes,
    },
    {
      value: 2,
      count: dislikes,
    },
  ];

  return (
    <>
      <div className="commentItem">
        <div className="commentMeta">
          <div className="commentAuthor">
            {author ? <ShortManInfo {...authorInfo} /> : "Система"}
          </div>
          <div className="commentDate">
            {formatDateOfEvent(new Date(date_created))}
          </div>
        </div>
        <div className="commentText">{comment}</div>
      </div>
      <CommentLikeRow comment_id={id} counters={likeCounters} />
    </>
  );
};

export default CommentItem;
